import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

/**
 * Renderer for the AH (AutoHedge) column for BM Hedge Orders. Renders a value with properties:{
 * isAutohedge:boolean;
 * isAcceptance:boolean;
 * }
 */
@Component({
  selector: "auto-hedge",
  template: `<span
    [hidden]="!isAutoHedge"
    class="badge-icon"
    [ngClass]="{
      'bfx-badge-info-bold': isOrderActive,
      'bfx-badge-neutral-moderate': !isOrderActive,
    }"
    >AH</span
  >`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AutoHedgeRenderer implements ICellRendererAngularComp {
  /**  Is this an Autohedge order - if so, show an icon */
  public isAutoHedge: boolean;
  /** Is order in acceptance - if true, use inactive state instead of active state */
  public isOrderActive: boolean;
  previous: { isAutoHedge: boolean; isOrderActive: boolean };

  constructor(public cd: ChangeDetectorRef) {
    this.previous = { isAutoHedge: this.isAutoHedge, isOrderActive: this.isOrderActive };
  }

  // called on init
  agInit(params: ICellRendererParams): void {
    this.doVal(params);
  }

  doVal(params: ICellRendererParams): boolean {
    this.previous.isAutoHedge = this.isAutoHedge;
    this.previous.isOrderActive = this.isOrderActive;

    this.isOrderActive = !params.value?.isAcceptance;
    this.isAutoHedge = params.value?.isAutoHedge === true;

    return (
      this.isAutoHedge !== this.previous.isAutoHedge ||
      this.isOrderActive !== this.previous.isOrderActive
    );
  }

  // called when the cell is refreshed
  refresh(params: ICellRendererParams): boolean {
    if (this.doVal(params)) {
      this.cd.markForCheck();
    }

    return true;
  }
}
